import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { IDetailsViewModel } from '@features/details/data-access/details.models';

/** Shared, expandable description with credit lines and geoblock note. */
@Component({
    selector: 'details-description',
    standalone: true,
    imports: [TranslocoPipe],
    templateUrl: './details-description.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsDescription {
    readonly vm = input.required<IDetailsViewModel>();
    readonly expanded = input(false);

    readonly toggle = output<void>();
}
